<template>
  <div id="app">
    <!-- 不加include是全部缓存，加了include是指针对某些组件页面缓存 -->
    <router-view />
    <!-- <van-tabbar style="z-index:11;" v-model="active" active-color="#00c4b6" route v-show="tabShow">
      <van-tabbar-item name="list" icon="description" to="/list">清单</van-tabbar-item>
      <van-tabbar-item name="scrap" icon="failure" to="/scrap">报废</van-tabbar-item>
      <van-tabbar-item name="warn" icon="bulb-o" to="/warn">警报</van-tabbar-item>
      <van-tabbar-item name="mine" icon="user-o" to="/mine">我的</van-tabbar-item>
    </van-tabbar> -->
    <!-- <div id="tabbt" v-show="tabShow">
      <ul>
        <li v-for="(item,index) in tabbar" :class="tabIndex === index ? 'selected' : ''" v-on:click="handover(index)">{{item.text}}
        </li>
      </ul>
    </div> -->
    <!-- <pupop-loading v-show="appShowLoading"></pupop-loading>
     -->
    <!-- <van-loading color="#0094ff" type="spinner" class="pupopLoading" v-show="appShowLoading" size="40"/> -->
    <pupop-hint v-show="showMessage" v-on:cancelPupopHint="closeTitle" v-on:getBack="sureTitle">
      <div slot="title" class="title">{{errorMessage}}</div>
    </pupop-hint>
  </div>
</template>

<script>
  import {sizeChange,getParam} from './assets/js/common';
  import pupopHint from './components/common/pupopHint'
  import pupopLoading from './components/common/pupopLoading'
  import Cookies from 'js-cookie'
export default {
  name: 'app',
  data(){
    return{
      keepAliveList:["scrap"],
      active:'list',
      promit:true,
      tabbar: [
        {
          text  : '清单',
          router: '/list'
        },
        {
          text  : '报废',
          router: '/scrap'
        },
        {
          text  : '警报',
          router: '/warn'
        },
        {
          text  : '我的',
          router: '/mine'
        }
      ]
    }
  },
  created(){
    this.setBtTab();
    this.unLoad();
    this.context();
  },
  mounted(){
    sizeChange();
  },
  methods: {
    context(){
      let schCode=getParam('schCode');
      // schCode='an1';
      console.log(process.env.schCode)

      if(process.env.NODE_ENV=='development'){
        schCode=process.env.schCode;
      }
      console.log(schCode)
      if(schCode){
        Cookies.set('schCode',schCode);
      }else{
        schCode=Cookies.get('schCode');
      }
      // if(schCode==null || schCode=='null'){
      //   this.$dialog.alert({
      //     title:'警告',
      //     showConfirmButton:false,
      //     message: '请在微信公众号下方点击按钮重新进行访问'
      //   }).then(() => {
      //     // on close
      //   });
      // }
      this.$store.state.context=process.env.context;
      // if(process.env.NODE_ENV==='production'){
      //   this.$store.state.context='https://gateway.scigeeker.com/v3/api/'+schCode;
      // }else if(process.env.NODE_ENV==='ptest'){
      //   this.$store.state.context = 'http://gateway.demo.scigeeker.com/btlock_rmsapi/'+schCode;
      // }else if(process.env.NODE_ENV==='testing'){
      //   this.$store.state.context = 'http://192.168.10.79:8300/'+schCode;
      // }else if(process.env.NODE_ENV==='btest'){
      //   this.$store.state.context = 'http://192.168.10.79:8100/'+schCode;
      // }else{
      //   this.$store.state.context = 'http://192.168.10.79:8100/'+schCode;
      // }
    },
    sureTitle(){
      var self=this;
      self.$store.state.showMessage=false;
    },
    closeTitle(){
      var self=this;
      self.$store.state.showMessage=false;
    },
    handover(index){
      var self=this;
        if(index==this.$store.state.tabIndex){
          return false
        }else{
          this.$store.state.tabIndex=index;
          this.$router.push(self.tabbar[index].router);
        }
    },
    setBtTab(){
      var self=this;
      window.addEventListener("popstate", function(e) {
        var pathName=window.location.pathname;
        switch (pathName){
          case '/list':
            self.$store.state.tabIndex=0;
            break;
          case '/scrap':
            self.$store.state.tabIndex=1;
            break;
          case '/warn':
            self.$store.state.tabIndex=2;
          case '/mine':
            self.$store.state.tabIndex=3;
            break;
        }
      }, false);
    },
    unLoad(){
      var self=this;
      window.addEventListener("load", function(e) {
        var pathName=window.location.pathname;
        switch (pathName){
          case '/list':
            self.$store.state.tabIndex=0;
            break;
          case '/scrap':
            self.$store.state.tabIndex=1;
            break;
          case '/warn':
            self.$store.state.tabIndex=2;
            break;
          case '/mine':
            self.$store.state.tabIndex=3;
            break;
        }
      }, false);
    }
  },
  components:{
    'pupop-loading':pupopLoading,
    'pupop-hint':pupopHint
  },
  computed:{
    tabShow(){
      return this.$store.state.tabShow;
    },
    tabIndex(){
      return this.$store.state.tabIndex;
    },
    appShowLoading(){
      return this.$store.state.appShowLoading;
    },
    showMessage(){
      return this.$store.state.showMessage;
    },
    errorMessage(){
      return this.$store.state.errorMessage;
    }
  },
  watch:{

  }
}
</script>

<style lang="scss">
  @import "./assets/css/reset";
  @import "./assets/css/common";
  #app{
    padding-bottom: 80px;
  }
  div.pupopLoading{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  #tabbt {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    height: 1rem;
    background-color: #f8f8f8;
    z-index: 9;
    ul {
      width: 100%;
      overflow: hidden;
    }
    li {
      width:25%;
      -webkit-background-size: 0.48rem;
      background-size: 0.48rem;
      background-position: center 0.13rem;
      height: 1rem;
      float: left;
      text-align: center;
      font-size: 0.25rem;
      padding-top:0.66rem;
      position: relative;
      em {
        width: 0.16rem;
        height: 0.16rem;
        position: absolute;
        top: 0.1rem;
        right: 0.44rem;
        background-color: #eb4e51;
        border-radius: 50%;
        color: #fff;
      }
    }
    li.selected {
      color: #00c4b6;
    }
    li:nth-of-type(1) {
      background-image: url(./assets/image/listIcon.png);
      background-size: 0.34rem;
    }
    li.selected:nth-of-type(1) {
      background-image: url(./assets/image/listAactive.png);
      background-size: 0.34rem;
    }
    li:nth-of-type(2) {
      background-image: url(./assets/image/scrapIcon.png);
      background-size: 0.44rem;
    }
    li.selected:nth-of-type(2) {
      background-image: url(./assets/image/scrapActive.png);
      background-size: 0.44rem;
    }
    li:nth-of-type(3) {
      background-image: url(./assets/image/warnIcon.png);
      background-size: 0.54rem;
    }
    li.selected:nth-of-type(3) {
      background-image: url(./assets/image/warnActive.png);
      background-size: 0.54rem;
    }
    li:nth-of-type(4) {
      background-image: url(./assets/image/mineIcon.png);
      background-size: 0.46rem;
    }
    li.selected:nth-of-type(4) {
      background-image: url(./assets/image/mineActive.png);
      background-size: 0.46rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue